import React, { FunctionComponent, useCallback } from 'react';

import { Quote as QuoteType } from '@gojob/cms';
import PaletteProvider from '@gojob/ui-bits/styles/PaletteProvider';
import useTranslation from '../../translations/useTranslation';
import Scroller from '../Scroller';
import Quote from './Quote';

export type QuoteScrollerProps = {
  items?: QuoteType[];
};

const QuoteScroller: FunctionComponent<QuoteScrollerProps> = (props) => {
  const { items = [] } = props;
  const t = useTranslation();

  const renderDotAriaLabel = useCallback(
    (index: number) => {
      const author = items[index]?.author_name || '';
      return t('quote_of_{author}', { author });
    },
    [items, t]
  );

  return (
    <PaletteProvider variant="primary">
      <Scroller showDots renderDotAriaLabel={renderDotAriaLabel}>
        {items.map((item, index) => {
          const { text, avatar, author_name, author_role } = item;
          return (
            <Quote key={index} image={avatar} authorName={author_name} authorRole={author_role}>
              {text}
            </Quote>
          );
        })}
      </Scroller>
    </PaletteProvider>
  );
};

export default QuoteScroller;
